'use strict';

module.exports = {
    getUrl: Odigeo._.constant('isrenewalatfirstbooking'),

    getMethod: Odigeo._.constant('GET'),

    requestSuccess(data) {
        Odigeo.trigger(`${this.widget.id}:isRenewalAtFirstBookingOk`, data);
    },

    requestError: Odigeo._.noop,
};
